import React, { useRef } from 'react';
import { useDrop, useDrag, DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { useTranslation } from 'react-i18next';
import CompanyDetails from '../ComapyDetails';

function CompanyRecivingEnd({ element, eleIndex, dropLocation, fromForm }) {
  const cardRef = useRef(null);
  const { t } = useTranslation('common');

  const [{ itemDragging }] = useDrag({
    type: 'container',
    collect: (monitor) => ({
      itemDragging: monitor.getItem(),
    }),
  });

  const [{ cardOver, item }, drop] = useDrop({
    accept: 'container',
    drop: () => {
      dropLocation(eleIndex, item);
    },
    collect: (monitor) => ({
      item: monitor.getItem(),
      cardOver: monitor.isOver(),
    }),
  });

  drop(cardRef);
  return (
    <DndProvider backend={HTML5Backend}>
      <div ref={cardRef}>
        {cardOver && <div className="potemplate-drag-placeholder">{t('PO_TEMPLATES.PO_DETAILS.RECIVING_END.COMPANY_RECIVING_END.DROP_SECTION_HERE')}</div>}
        <CompanyDetails element={element} eleIndex={eleIndex} fromForm={fromForm} itemDragging={itemDragging} />
      </div>
    </DndProvider>
  );
}

export default CompanyRecivingEnd;
